import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { stubRestart } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class StubRestartModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      internationalization: this.props.intl.messages.stubStatusUpdate,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          btnLoading: true,
        });
        values.stubId = this.props.stubId;
        if (values.reservable == '0')
        {
          if (values.stubId.length == 11)
          {
            values.infoType = 3;
          } else {
            values.infoType = 1;
          }
        } else {
          if (values.stubId.length == 11)
          {
            values.infoType = 2;
          } else {
            message.error('非HPC设备不支持硬复位');
            this.setState({
              btnLoading: false,
            });
            return;
          }
        }
        fetchHandler(stubRestart, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && (res.code === "ok" || res.code === "success")) {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label={'复位方式'}>
            {getFieldDecorator("reservable", {
              rules: [
                {
                  required: true,
                  message: '请选择复位方式', // "请选择要修改的状态"
                },
              ],
            })(
              <Radio.Group>
                <Radio key="0" value="0">软复位</Radio>
                <Radio key="1" disabled={(this.props.stubId.length == 11 && this.props.stubId.substr(0, 1) == '8') ? false : true} value="1">硬复位（HPC设备支持）</Radio>
              </Radio.Group>,
              )}
          </FormItem>
          <FormItem {...formItemLayout} label={'复位范围'}>
            {getFieldDecorator("backType", {
              rules: [
                {
                  required: true,
                  message: '请选择复位范围', // "请选择复位范围"
                },
              ],
            })(
              <Radio.Group>
                <Radio key="0" value="0">单枪</Radio>
                <Radio key="1" disabled={(this.props.stubId.length == 11 && this.props.stubId.substr(0, 1) == '8') ? false : true} value="1">整桩（HPC设备支持）</Radio>
              </Radio.Group>,
              )}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const StubRestartModalS = Form.create()(StubRestartModal);

export default injectIntl(StubRestartModalS);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubRestartModal.js